export default "__VITE_ASSET__pLKLe1nj__"